"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated Use React.createRef.
 * May be removed in 6 months (Jan '19).
 */
function createRef() {
    var refObject = (function (element) {
        refObject.current = element;
    });
    // This getter is here to support the deprecated value prop on the refObject.
    Object.defineProperty(refObject, 'value', {
        get: function () {
            return refObject.current;
        }
    });
    refObject.current = null;
    return refObject;
}
exports.createRef = createRef;
//# sourceMappingURL=createRef.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uifabric/utilities/lib-commonjs/createRef.js
// module id = 520
// module chunks = 0